// extracted by mini-css-extract-plugin
module.exports = {"description":"QcmLink_description__3so0s"};